module.exports = __webpack_public_path__ + "assets/img/title-84626a14.png";